export default {
  name: "KilaKilaWifeCover"
};